import React, { useEffect, useState } from "react";

import Elearning from './AllPages/E-Learning'
import Adventure from './AllPages/Adventure'
import ParentsFinds from './AllPages/ParentsFindsKidskite'
import UnlockSection from './AllPages/UnlockEndless'
import YTVideo from './AllPages/YoutubeContent'
import Footer from './AllPages/Footer'
import YTmobile from './AllPages/YTmobile'
import Mobilefooter from './AllPages/MobileFooter'

const AllPage = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div>
      <Elearning />
      <Adventure />
      <ParentsFinds />
      <UnlockSection />
      {windowWidth <= 820  ? <YTmobile /> : <YTVideo />}
      {windowWidth <= 820  ? <Mobilefooter /> : <Footer />}
      {/* <Footer /> */}
    </div>
  );
};

export default AllPage;
